import { ensureHiddenTextareaMinFont } from '../../../utils/ensure-hidden-textarea-min-font';

type ApplyOverlayTextStylesProps = {
  overlayTextarea: HTMLTextAreaElement;
  overlayContainer: HTMLElement;
  fabricTextbox: fabric.Textbox;
  canvasZoom: number;
  isPhotoTextZone?: boolean;
  isMobile?: boolean;
};

export const applyOverlayTextStyles = ({
  overlayTextarea,
  overlayContainer,
  fabricTextbox,
  canvasZoom,
  isPhotoTextZone,
  isMobile = false,
}: ApplyOverlayTextStylesProps) => {
  if (!overlayTextarea || !overlayContainer || !fabricTextbox) {
    throw new Error('Overlay textarea or fabric textbox is not defined');
  }

  const scale = fabricTextbox.scaleY || 1;

  // Set styles with fallbacks
  const textboxColor = fabricTextbox?.fill || 'black';
  const fontSize = fabricTextbox?.fontSize || 16;
  const padding = fabricTextbox?.padding || 5;
  const textAlign = fabricTextbox?.textAlign || 'left';
  const fontWeight = fabricTextbox.fontWeight || 'normal';
  const fontFamily = fabricTextbox.fontFamily || 'Arial';
  const angle = fabricTextbox.angle || 0;
  const overlayBorderWidth = 2;

  const zoomedPadding = padding * canvasZoom - overlayBorderWidth;
  const zoomedAngle = angle * scale;

  // Line height needs to be converted to px to scale properly
  const lineHeight = fabricTextbox.getHeightOfLine(0);
  const zoomedLineHeight = lineHeight * canvasZoom * scale - overlayBorderWidth;
  const zoomedFontSize = fontSize * canvasZoom * scale;

  overlayTextarea.style.color = textboxColor.toString();
  overlayTextarea.style.fontWeight = fontWeight.toString();
  overlayTextarea.style.fontFamily = fontFamily;
  overlayTextarea.style.textAlign = textAlign;

  overlayTextarea.style.fontSize = `${zoomedFontSize.toString()}px`;
  overlayTextarea.style.lineHeight = `${zoomedLineHeight.toString()}px`;
  overlayContainer.style.transformOrigin = 'center center';
  if (isPhotoTextZone) {
    const counterScale = isMobile ? ensureHiddenTextareaMinFont(overlayTextarea, true) : null;
    if (counterScale) {
      overlayTextarea.style.lineHeight = `${zoomedLineHeight / counterScale}px`;
    }
  } else {
    overlayTextarea.style.padding = `${zoomedPadding}px`;
    overlayContainer.style.transform = `rotate(${zoomedAngle}deg) translateY(${-(overlayBorderWidth / 2)}px)`;
    const counterScale = isMobile ? ensureHiddenTextareaMinFont(overlayTextarea, true) : null;
    if (counterScale) {
      overlayTextarea.style.lineHeight = `${zoomedLineHeight / counterScale}px`;
      overlayTextarea.style.padding = `${zoomedPadding / counterScale}px`;
    }
  }

  return { overlayTextarea };
};
